/* oxlint-disable react/forbid-elements */
import * as React from 'react';

export const ProblemLargeIcon = (): React.JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
      <path
        fill="#FF5050"
        fillRule="evenodd"
        d="M0 16c4.616-2.189 8.883-4.589 12.8-7.2A92.349 92.349 0 0 0 24 0c3.384 3.145 7.117 6.078 11.2 8.8A97.103 97.103 0 0 0 48 16v4.21h-5.053V44a4 4 0 0 1-4 4H9.053a4 4 0 0 1-4-4V20L0 20.21V16zm35.416 1.081a1 1 0 0 0-1.414 0l-8.795 8.795a1 1 0 0 1-1.414 0l-8.795-8.795a1 1 0 0 0-1.414 0l-1.503 1.503a1 1 0 0 0 0 1.414l8.795 8.795a1 1 0 0 1 0 1.414l-8.795 8.795a1 1 0 0 0 0 1.414l1.503 1.503a1 1 0 0 0 1.414 0l8.795-8.795a1 1 0 0 1 1.414 0l8.795 8.795a1 1 0 0 0 1.414 0l1.503-1.503a1 1 0 0 0 0-1.414l-8.795-8.795a1 1 0 0 1 0-1.414l8.795-8.795a1 1 0 0 0 0-1.414l-1.503-1.503z"
      />
    </svg>
  );
};
